import React, { useState, useRef, useEffect } from 'react';
import './Navbar.css';
import Logo from "../assets/logo v4.png";
import { Avatar } from '@mui/material';
import { useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import user from '../assets/user.png';
import edit from '../assets/edit.png';
import EditProfileModal from './EditProfileModal';

function stringToColor(string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      fontSize: '0.875rem', // 可以調整這個值來改變字體大小，例如：'0.875rem' (較小) 或 '1.2rem' (較大)
    },
    children: `${name.split('').map((char, index) => index > 0 ? char : '').join('')}`,
  };
}

function DropdownItem({ img = '', text = '', onClick = null }) {
  return (
    <li className="dropdownItem" onClick={onClick}>
      <img src={img} alt={text} />
      <a>{text}</a>
    </li>
  );
}

/**
 * StudentWallNavbar - 學生端牆面專用導航列
 */
const StudentWallNavbar = ({ currentWall = 'idea', onWallChange, menuGroups = [], courseDispatchId, groupId }) => {
  const [avatarOpen, setAvatarOpen] = useState(false);
  const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
  const avatarRef = useRef();
  const signOut = useSignOut();
  const navigate = useNavigate();
  
  const name = localStorage.getItem('name') || '學生';
  const userRole = localStorage.getItem('userRole') || 'student';

  const handleBackToCourse = () => {
    // 檢查用戶角色：如果是老師，返回老師的想法管理頁；如果是學生，返回學生課程列表
    if (userRole === 'teacher' && courseDispatchId) {
      // 老師從學生視角返回時，應該回到老師的想法牆管理頁
      navigate(`/teacher/implementation/community-applications/${courseDispatchId}/idea-wall`);
    } else {
      // 學生返回課程列表
    navigate('/student/my-classes');
    }
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (avatarRef.current && !avatarRef.current.contains(e.target)) {
        setAvatarOpen(false);
      }
    };
    
    if (avatarOpen) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    
    return () => document.removeEventListener('mousedown', handleClick);
  }, [avatarOpen]);

  const handleOpenEditProfile = () => {
    setIsEditProfileOpen(true);
    setAvatarOpen(false);
  };

  const handleCloseEditProfile = () => {
    setIsEditProfileOpen(false);
  };

  const switchToTeacher = () => {
    navigate('/teacher/preparation');
  };

  const logout = () => {
    signOut();
    navigate("/");
    localStorage.removeItem('userId');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
    localStorage.removeItem('activityId');
    localStorage.removeItem('groupId');
    localStorage.removeItem('nodeId');
    localStorage.removeItem('nodeDataLength');
    localStorage.removeItem('jwtToken');
  };
  
  return (
    <>
      {/* 上方平台標題、logo與頭像 */}
      <nav className="main-navbar modern-navbar" style={{
        position:'fixed',
        top:0,
        left:0,
        right:0,
        height:64,
        display:'flex',
        alignItems:'center',
        justifyContent:'space-between',
        background:'#2b687f',
        color:'#fff',
        zIndex:2000,
        boxSizing: 'border-box'
      }}>
        <div style={{display:'flex',alignItems:'center',gap:16}}>
          <img alt="logo" src={Logo} className="navbar-logo circle" style={{width:40,height:40,background:'#fff'}} />
          <span className="navbar-title" style={{fontSize:'1.35rem',fontWeight:'bold',letterSpacing:2,color:'#fff'}}>想法探究平台</span>
          {/* 返回課程按鈕 */}
          <button 
            onClick={handleBackToCourse}
            style={{
              padding: '6px 16px',
              borderRadius: '20px',
              border: '2px solid rgba(255,255,255,0.5)',
              backgroundColor: 'transparent',
              color: '#fff',
              fontSize: '0.85rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontWeight: '500'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
              e.target.style.borderColor = 'rgba(255,255,255,0.8)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = 'rgba(255,255,255,0.5)';
            }}
          >
            ← 返回課程
          </button>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:16}}>
          {/* 牆面導覽 - 模仿教學階段導覽 */}
          <div className="teaching-phase-navigation" style={{display:'flex',alignItems:'center',gap:16}}>
            <button 
              className={`phase-button ${currentWall === 'idea' ? 'active' : ''}`}
              onClick={() => onWallChange && onWallChange('idea')}
              style={{
                padding: '8px 16px',
                borderRadius: '20px',
                border: 'none',
                backgroundColor: currentWall === 'idea' ? '#1976d2' : 'rgba(255,255,255,0.2)',
                color: '#fff',
                fontSize: '0.9rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              💡 想法牆
            </button>
            <button 
              className={`phase-button ${currentWall === 'question' ? 'active' : ''}`}
              onClick={() => onWallChange && onWallChange('question')}
              style={{
                padding: '8px 16px',
                borderRadius: '20px',
                border: 'none',
                backgroundColor: currentWall === 'question' ? '#1976d2' : 'rgba(255,255,255,0.2)',
                color: '#fff',
                fontSize: '0.9rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              ❓ 問題牆
            </button>
            <button 
              className={`phase-button ${currentWall === 'cross_group' ? 'active' : ''}`}
              onClick={() => onWallChange && onWallChange('cross_group')}
              style={{
                padding: '8px 16px',
                borderRadius: '20px',
                border: 'none',
                backgroundColor: currentWall === 'cross_group' ? '#1976d2' : 'rgba(255,255,255,0.2)',
                color: '#fff',
                fontSize: '0.9rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              💬 跨組討論
            </button>
            <button 
              className={`phase-button ${currentWall === 'analytics' ? 'active' : ''}`}
              onClick={() => {
                try {
                  // 優先從 props 獲取，否則從 sessionStorage/localStorage 獲取
                  const cdId = courseDispatchId || sessionStorage.getItem('courseDispatchId') || sessionStorage.getItem('activityId') || localStorage.getItem('courseDispatchId') || localStorage.getItem('activityId');
                  const gId = groupId || sessionStorage.getItem('groupId') || localStorage.getItem('groupId');
                  if (cdId && gId) {
                    navigate(`/student/analytics/${cdId}/${gId}`);
                  } else {
                    console.warn('[StudentWallNavbar] 無法導航到儀表板：缺少 courseDispatchId 或 groupId', { courseDispatchId: cdId, groupId: gId });
                  }
                } catch (e) {
                  console.error('[StudentWallNavbar] 導航到儀表板失敗:', e);
                }
              }}
              style={{
                padding: '8px 16px',
                borderRadius: '20px',
                border: 'none',
                backgroundColor: currentWall === 'analytics' ? '#1976d2' : 'rgba(255,255,255,0.2)',
                color: '#fff',
                fontSize: '0.9rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              📊 我的儀表板
            </button>
          </div>
          {/* 頭像下拉選單 */}
          <div ref={avatarRef} style={{position: 'relative', display: 'flex', alignItems: 'center'}}>
            <div className="menu-trigger" onClick={() => setAvatarOpen(!avatarOpen)}>
              <Avatar {...stringAvatar(name)} />
            </div>
            <div className={`dropdown-menu ${avatarOpen ? 'active' : 'inactive'}`}>
              <h3>嗨！{name}</h3>
              <ul>
                <DropdownItem
                  img={edit}
                  text={"編輯個人資料"}
                  onClick={handleOpenEditProfile}
                />

              </ul>
              <h3><button className='register-button1' onClick={logout}>登出</button></h3>
            </div>
          </div>
        </div>
      </nav>

      <EditProfileModal
        open={isEditProfileOpen}
        onClose={handleCloseEditProfile}
      />
    </>
  );
};

export default StudentWallNavbar;


